var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5527864,2.2763932 L2.0527864,13.2763932 C1.88656113,13.6088437 2.12830899,14 2.5,14 L13.5,14 C13.871691,14 14.1134389,13.6088437 13.9472136,13.2763932 L8.4472136,2.2763932 C8.26295146,1.90786893 7.73704854,1.90786893 7.5527864,2.2763932 Z M8,3.618 L12.69,13 L3.309,13 L8,3.618 Z",
    id: "Triangle",
    fill: "#ffffff",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangle);
export default __webpack_public_path__ + "static/media/Triangle.061fa4ae71126a1eff1440c2791e46c7.svg";
export { ForwardRef as ReactComponent };